// react
import { Suspense, useState } from 'react';

// tanstack
import { createFileRoute, useLocation } from '@tanstack/react-router';

// material ui
import {
  Box,
  CircularProgress,
  Container,
  Fade,
  Grid,
  Pagination,
} from '@mui/material';

// feature-components
import OperationsDetailCard from '@/features/building-optimization/components/operations/OperationsDetailCard';

// components
import FilterPanel from '@/features/operations/predictive-heat-control/FilterPanel';
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute(
  '/$accountId/_admin/operations/predictive-heat-control/groups/$groupKey',
)({
  component: RouteComponent,
  errorComponent: ErrorBoundary,
});

function RouteComponent() {
  const location = useLocation();
  const accounts = location.state.accountGroup || [];
  const [page, setPage] = useState(1);
  const itemsPerPage = 16;

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const [activeFilter, setActiveFilter] = useState(
    location.state?.activeFilter || true,
  );

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const paginatedBuildings = accounts
    .flatMap((account) => account.Buildings || [])
    .slice(startIndex, endIndex);

  return (
    <Container maxWidth={false}>
      <FilterPanel
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
      />
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        <Grid container spacing={4} sx={{ mt: 1 }}>
          {paginatedBuildings.map((building, index) => (
            <Grid key={index} size={3}>
              <Fade in={true} timeout={500}>
                <Box>
                  <OperationsDetailCard
                    activeFilter={activeFilter}
                    accounts={accounts}
                    building={building}
                  />
                </Box>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Suspense>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Pagination
          count={Math.ceil(
            accounts.flatMap((account) => account.Buildings || []).length /
              itemsPerPage,
          )}
          page={page}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Container>
  );
}
